module.exports = __webpack_public_path__ + "img/sql.f7a490e3.png";